import { useTranslation } from 'react-i18next';
import { galleryItems } from '@pages/gallery/galleryItems';



export interface PhotoItemObject {
	image: any,
	key: (typeof galleryItems)[number]['key'],
}



interface PhotoItemProps {
	item: PhotoItemObject,
}


const PhotoItem = (props: PhotoItemProps) => {
	const { image, key } = props.item;
	const { t } = useTranslation('web');

	const name = t(`pages.gallery.galleryItems.${key}.name`);
	const text = t(`pages.gallery.galleryItems.${key}.text`);

	return (
		<div className="photo-item">
			
			<img src={image} alt='gallery-photo' draggable={false} />

			{text && text.length > 0 &&
				<div className='photo-item-text'>
					
					<p className='customer-text'>{text}</p>
					
					{name && name.length > 0 &&
						<p className='customer-name'>{name}</p>}
				
				</div>}
		</div>
	);
};

export default PhotoItem;